import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import './admin.css';
import MenuLeft from '../MenuLeft/MenuLeft';
import TopMenu from '../TopMenu/TopMenu';

const Admin = () => {
    const [wMenuLateral, setWMenuLateral] = useState('15%');
    const [wContainerAdmin, setWContainerAdmin] = useState('100%');
    const [colapsed, setColapsed] = useState(false);

    return (
        <div className="bg-[#e8fafd] min-h-screen">
            <div className="flex m-0 p-0">
                {/* Menú lateral fijo */}
                <div className="h-screen m-0 pr-2.5 pb-4 align-top fixed overflow-hidden z-99 transition-all duration-300 max-md:hidden" style={{ width: wMenuLateral }}>
                    <MenuLeft
                        colapsed={colapsed}
                        setColapsed={setColapsed}
                        setWContainerAdmin={setWContainerAdmin}
                        setWMenuLateral={setWMenuLateral}
                    />
                </div>

                {/* Contenedor principal */}
                <div className="w-full align-top h-screen overflow-y-auto m-0 admin-scrollbar transition-all duration-300" style={{ width: wContainerAdmin }}>
                    {/* Top menu móvil */}
                    <div className="md:hidden m-0 p-0">
                        <TopMenu />
                    </div>

                    <div className="transition-all duration-300 max-md:pl-0" style={{ paddingLeft: wMenuLateral }}>
                        {/* Top menu desktop */}
                        <div className="max-md:hidden">
                            <TopMenu />
                        </div>

                        {/* Contenido principal (Outlet) */}
                        <div className="m-0 p-0">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Admin;